import { GET } from "Data/API/Request";

export const getPartNumbers = (token: string) => {
	return GET("part-numbers", token) as unknown as Promise<string[]>;
};
